import { render, staticRenderFns } from "./demonstrationBaseForm.vue?vue&type=template&id=437f43db&scoped=true&"
import script from "./demonstrationBaseForm.vue?vue&type=script&lang=js&"
export * from "./demonstrationBaseForm.vue?vue&type=script&lang=js&"
import style0 from "./demonstrationBaseForm.vue?vue&type=style&index=0&id=437f43db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437f43db",
  null
  
)

export default component.exports